<form
    onsubmit="return false;"
    class="shadow-bar p-half md:p-1 md:py-half"
>
    <div class="flex gap-qtr md:gap-half flex-wrap md:flex-nowrap items-center">
        <Keywords/>
        <dialog id="filter-dialog" class="w-full md:w-[600px] xl:w-[650px] shadow-lg p-1 lg:p-1.5 backdrop:bg-black/50">
            <h2 class="h5 pb-1 filter-dialog__title border-b border-gray-300 relative">
                Filters
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute top-0 right-0 w-1.5 h-1.5 text-primary cursor-pointer">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </h2>
            <div id="filter-content">
                <template v-if="isEventsPage">
                    <h3 class="h6">
                        By Date
                    </h3>
                    <Date />
                </template>
                <Categories />
                <Regions />
                <Locations />
                <Facets />
                <div class="flex justify-between">
                    <button class="button m-0 hollow" value="clear" v-on:click="clearFilters">Clear filters</button>
                    <button class="button m-0" value="cancel" formmethod="dialog" v-on:click="hideFilters">Show <span
                            v-if="resultsStore.pageInfo">({{ resultsStore.pageInfo.totalCount }})</span>
                        results</button>
                </div>
            </div>
        </dialog>
        <div class="text-lightgray flex mt-qtr md:mt-0 items-center justify-items-start h-4 order-3 lg:order-2 w-full">
            <div
                v-if="isEventsPage"
                class="
                    flex
                    shrink-0
                    basis-[75px]
                    lg:basis-[110px]
                    items-center
                    pr-0.75
                    md:pl-0.75
                    text-[10px]
                    md:text-[11px]
                    text-center
                    font-bold
                    uppercase
                ">
                Quick date search
            </div>
            <div v-else-if="hasQuickFilters" class="
                    flex
                    shrink-0
                    basis-[65px]
                    md:basis-[85px]
                    items-center
                    pr-0.75
                    border-r
                    mr-0.75
                    text-[10px]
                    md:text-[11px]
                    text-center
                    font-bold
                    uppercase
                ">
                Quick filters
            </div>
           
                <template v-if="isEventsPage">
                    <Date />
                </template>
                <template v-else-if="hasQuickFilters">
                    <QuickFilters />
                </template>
        
        </div>
        <button class="button flex items-center h-[54px] md:h-auto md:shrink-0 md:basis[100px] m-0 order-2 lg:order-3"
            v-on:click="showFilters">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-1.25 h-1.25 md:mr-half">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z" />
            </svg>
            <span class="sr-only md:not-sr-only">
                Filters
            </span>
        </button>
    </div>
</form>
